import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
export function MobileBanner() {
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 60); // 2 hours
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="md:hidden fixed top-0 left-0 right-0 z-50 bg-[#C41E3A] text-white py-2 px-4 shadow-md flex items-center justify-center gap-2" data-id="element-33">
      <FlameIcon className="w-4 h-4 text-yellow-300 animate-pulse" data-id="element-34" />
      <span className="text-sm font-bold" data-id="element-35">
        Oferta Especial HOY en $4.99 - {formatTime(timeLeft)}
      </span>
    </div>;
}